import React from 'react';

interface OptionCyclerProps {
  label?: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}

export const OptionCycler: React.FC<OptionCyclerProps> = ({ label = 'option', value, options, onChange }) => {
  const index = Math.max(0, options.indexOf(value));
  const next = () => onChange(options[(index + 1) % options.length]);
  const previous = () => onChange(options[(index - 1 + options.length) % options.length]);

  return (
    <div className="cc-cycler">
      <button type="button" className="cc-cycler-btn" onClick={previous} aria-label={`Previous ${label}`}>‹</button>
      <output className="cc-cycler-value" aria-live="polite">{value}</output>
      <button type="button" className="cc-cycler-btn" onClick={next} aria-label={`Next ${label}`}>›</button>
    </div>
  );
};
